import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import elementClickedListener from '../analytics/elementClickedListener';
import {
  BudgetStatusProvider,
  BudgetStatusTile
} from '@ramsey-plus-components/budget-status-ui';

const ENV = {
  development: 'TEST',
  test_one: 'TEST',
  qa: 'QA',
  production: 'PROD'
};

const BudgetStatus = ({ jwt }) => {
  const environment = ENV[window.PUBLIC_CONSTS.ENVIRONMENT];

  useEffect(() => {
    window.localStorage.setItem('lastSeenBudgetStatus', Date.now());
  }, []);

  return (
    <BudgetStatusProvider
      token={jwt}
      environment={environment}
      onComplete={elementClickedListener}
    >
      <BudgetStatusTile />
    </BudgetStatusProvider>
  );
};

BudgetStatus.propTypes = {
  jwt: PropTypes.string.isRequired
};

export default BudgetStatus;
